export default __webpack_public_path__ + "static/media/spnBatua.66200e82.JPG";